<div class="page">
  <div class="spacer"></div>
  <div class="voice-check-hint" [class.invisible]="isRecording">
    @let hint = getHint();
    @if (hint) {
      <span trans="voice_check.record.hint.{{hint}}"></span>
    }
  </div>

  <div class="voice-check-phrase" [class.active]="isRecording">
    <span class="text" trans="voice_check.record.phrase" [transLocale]="locale"></span>
  </div>

  <app-voice-visualiser class="voice-visualiser" [meter]="meter" [active]="isRecording"></app-voice-visualiser>
  <app-media-recorder #recorder mimeType="audio/webm"></app-media-recorder>

  <div class="button-area">
    @let dev_view = false;
    @if (showStatuses || dev_view) {
      <div class="status-row">
        @for (recording of recordings; track recording.id; let idx = $index) {
          <div class="status" [attr.data-status]="recording.status">
            @if (recording.status === LoadingStatus.Success) {
              <mat-icon>check</mat-icon>
            }
            @if (recording.status === LoadingStatus.Failed) {
              <mat-icon>close</mat-icon>
            }
          </div>
        }
      </div>
    }

    <div class="stop-recording-cta-box">
      <div class="stop-recording-cta" [class.visible]="shouldShowStopRecordingCta()">
        <div trans="voice_check.record.hint.tapAgain" class="text"></div>
        <mat-icon>arrow_downward</mat-icon>
      </div>
    </div>

    @if (recordingEnabled) {
      <app-voice-record-button
        class="record-button"
        [disabled]="!stream || !recordingEnabled"
        [maximumTime]="MAX_RECORDING_TIME"
        (started)="startRecording()"
        (stopped)="endRecording($event)"
        [isCountDownEnabled]="true"
        >
      </app-voice-record-button>
    } @else {
      <div class="spinner">
        <div class="inner"></div>
      </div>
    }

    @if (recordingEnabled) {
      @if (!isRecording) {
        <div class="record-hint" trans="voice_check.record.recordButtonText.tapStart"></div>
      }
      @if (isRecording) {
        <div class="record-hint" trans="voice_check.record.recordButtonText.tapStop"></div>
      }
    } @else {
      <div class="record-hint" trans="voice_check.record.recordButtonText.uploading"></div>
    }
  </div>
</div>
